<script setup lang="ts">
const props = defineProps<{
    src: string
    loading: boolean
}>()

const emit = defineEmits<{
    load: []
}>()
</script>

<template>
    <div class="promotion-iframe">
        <iframe
            :src="props.src"
            data-recording-gdpr-safe
            @load="emit('load')"
        />

        <Transition name="fade">
            <UILoader v-if="props.loading" />
        </Transition>
    </div>
</template>

<style lang="scss" scoped>
.promotion-iframe {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: z(take-over);
    background-color: rgba(0, 0, 0, 0.4);

    iframe {
        display: block;
        width: 100%;
        height: 100%;
        border: 0;
    }
}
</style>
